import { TLanguage } from "../../Common/other";

export const COMPANY_PHONE = "+84 28 7300 1811";
export const COMPANY_EMAIL = "info@exceltech.vn";

export type TPolicyBlock =
  | { type: "p"; text: string }
  | { type: "h4"; text: string }
  | { type: "ul"; items: string[] };

export interface TPolicySection {
  id: string;
  title: string;
  blocks: TPolicyBlock[];
}

export interface TPolicyContent {
  intro: string;
  updatedAt: string;
  sections: TPolicySection[];
  company: {
    brand: string;
    legalName: string;
  };
}

// NOTE: Text wrapped in [square brackets] is a placeholder that must be
// replaced with the company's official information before publishing.
export const PRIVACY_POLICY_CONTENT: { [key in TLanguage]: TPolicyContent } = {
  vn: {
    updatedAt: "Tháng 9, 2026",
    intro:
      "Chính sách bảo mật này mô tả cách thức Excel Technologies (ExcelTech) – đơn vị sở hữu và vận hành trang web exceltech.vn (gọi tắt là “Trang web” hoặc “chúng tôi”) thu thập, sử dụng, lưu trữ và chia sẻ Thông Tin Cá Nhân của bạn khi bạn truy cập Trang web, gửi yêu cầu liên hệ, đăng ký nhận tin hoặc ứng tuyển thông qua Trang web.",
    sections: [
      {
        id: "thu-thap-thong-tin",
        title: "1. Thu thập Thông Tin Cá Nhân",
        blocks: [
          {
            type: "p",
            text: "Khi bạn truy cập Trang web, chúng tôi thu thập một số thông tin về thiết bị của bạn và cách bạn tương tác với Trang web. Khi bạn chủ động gửi biểu mẫu liên hệ, đăng ký nhận tin, trò chuyện trực tuyến hoặc ứng tuyển, chúng tôi thu thập thêm những thông tin bạn cung cấp để xử lý yêu cầu của bạn. Trong Chính sách bảo mật này, chúng tôi gọi bất kỳ thông tin nào có thể nhận diện một cá nhân cụ thể (bao gồm các thông tin dưới đây) là “Thông Tin Cá Nhân”.",
          },
          { type: "h4", text: "Thông tin thiết bị" },
          {
            type: "ul",
            items: [
              "Ví dụ về Thông Tin Cá Nhân thu thập: phiên bản trình duyệt web, địa chỉ IP, múi giờ, thông tin cookie, các trang bạn xem và cách bạn tương tác với Trang web.",
              "Mục đích thu thập: để hiển thị Trang web một cách chính xác cho bạn và phân tích việc sử dụng Trang web nhằm tối ưu hóa Trang web của chúng tôi.",
              "Nguồn thu thập: thu thập tự động khi bạn truy cập Trang web thông qua cookie và các công nghệ tương tự (ví dụ: Google Analytics).",
            ],
          },
          { type: "h4", text: "Thông tin liên hệ và yêu cầu tư vấn" },
          {
            type: "ul",
            items: [
              "Ví dụ về Thông Tin Cá Nhân thu thập: họ tên, số điện thoại, địa chỉ email, tên công ty, chức vụ và nội dung bạn gửi qua biểu mẫu “Liên hệ”.",
              "Mục đích thu thập: phản hồi yêu cầu của bạn, tư vấn về giải pháp và dịch vụ của chúng tôi.",
              "Nguồn thu thập: do bạn trực tiếp cung cấp.",
            ],
          },
          { type: "h4", text: "Thông tin đăng ký nhận tin" },
          {
            type: "ul",
            items: [
              "Ví dụ về Thông Tin Cá Nhân thu thập: địa chỉ email bạn đăng ký tại chân trang của Trang web.",
              "Mục đích thu thập: gửi cho bạn tin tức, sự kiện và thông tin cập nhật về giải pháp, dịch vụ của chúng tôi.",
            ],
          },
          { type: "h4", text: "Thông tin ứng tuyển" },
          {
            type: "ul",
            items: [
              "Ví dụ về Thông Tin Cá Nhân thu thập: họ tên, địa chỉ email, số điện thoại, hồ sơ năng lực (CV) và các thông tin khác bạn cung cấp khi ứng tuyển tại mục “Tuyển dụng”.",
              "Mục đích thu thập: đánh giá hồ sơ, liên hệ phỏng vấn và thực hiện quy trình tuyển dụng.",
            ],
          },
          { type: "h4", text: "Thông tin hỗ trợ trực tuyến" },
          {
            type: "ul",
            items: [
              "Ví dụ về Thông Tin Cá Nhân thu thập: tên, thông tin liên hệ và nội dung bạn trao đổi qua cửa sổ trò chuyện trực tuyến trên Trang web.",
              "Mục đích thu thập: hỗ trợ và giải đáp thắc mắc của bạn.",
            ],
          },
        ],
      },
      {
        id: "su-dung-thong-tin",
        title: "2. Sử dụng Thông Tin Cá Nhân",
        blocks: [
          {
            type: "p",
            text: "Chúng tôi sử dụng Thông Tin Cá Nhân của bạn cho các mục đích sau:",
          },
          {
            type: "ul",
            items: [
              "Phản hồi yêu cầu liên hệ, tư vấn và cung cấp thông tin về giải pháp, dịch vụ của chúng tôi;",
              "Xử lý hồ sơ ứng tuyển và liên hệ với ứng viên;",
              "Gửi tin tức, sự kiện và ưu đãi mới (bạn có thể hủy đăng ký bất cứ lúc nào);",
              "Phân tích, vận hành và cải thiện Trang web;",
              "Bảo đảm an toàn cho Trang web, phát hiện và ngăn chặn gian lận hoặc truy cập trái phép;",
              "Tuân thủ các nghĩa vụ theo quy định của pháp luật.",
            ],
          },
        ],
      },
      {
        id: "chia-se-thong-tin",
        title: "3. Chia sẻ Thông Tin Cá Nhân",
        blocks: [
          {
            type: "p",
            text: "Chúng tôi không bán Thông Tin Cá Nhân của bạn. Chúng tôi chỉ chia sẻ Thông Tin Cá Nhân với các nhà cung cấp dịch vụ giúp chúng tôi vận hành Trang web và xử lý yêu cầu của bạn như đã mô tả ở trên. Chúng tôi sử dụng các dịch vụ bổ sung sau:",
          },
          {
            type: "ul",
            items: [
              "Google Analytics (phân tích lượt truy cập): https://marketingplatform.google.com/about/analytics/",
              "EmailJS (chuyển tiếp nội dung biểu mẫu liên hệ đến hộp thư của chúng tôi): https://www.emailjs.com",
              "Mirabot – Tenten (trò chuyện trực tuyến): https://tenten.vn",
              "CX Genie (trò chuyện trực tuyến): https://cxgenie.ai",
              "YouTube (video nhúng trên Trang web): https://www.youtube.com",
            ],
          },
          {
            type: "p",
            text: "Chúng tôi cũng có thể chia sẻ Thông Tin Cá Nhân của bạn để tuân thủ các luật và quy định hiện hành, để phản hồi yêu cầu hợp pháp của cơ quan nhà nước có thẩm quyền, hoặc để bảo vệ quyền và lợi ích hợp pháp của chúng tôi.",
          },
        ],
      },
      {
        id: "phan-tich-quang-cao",
        title: "4. Phân tích và quảng cáo theo hành vi",
        blocks: [
          {
            type: "ul",
            items: [
              "Chúng tôi sử dụng Google Analytics để hiểu cách khách hàng sử dụng Trang web. Bạn có thể đọc thêm về cách Google sử dụng Thông Tin Cá Nhân của bạn tại: https://policies.google.com/privacy?hl=vi. Bạn cũng có thể chọn không tham gia Google Analytics tại: https://tools.google.com/dlpage/gaoptout",
              "Trong trường hợp chúng tôi sử dụng quảng cáo mục tiêu trên các nền tảng của bên thứ ba, thông tin về việc bạn sử dụng Trang web có thể được chia sẻ với các đối tác quảng cáo thông qua cookie hoặc các công nghệ tương tự (tùy theo sự đồng ý của bạn).",
            ],
          },
          {
            type: "p",
            text: "Để biết thêm thông tin về cách quảng cáo mục tiêu hoạt động, bạn có thể truy cập trang giáo dục của Network Advertising Initiative (“NAI”): https://thenai.org. Bạn có thể từ chối quảng cáo mục tiêu tại:",
          },
          {
            type: "ul",
            items: [
              "FACEBOOK – https://www.facebook.com/settings/?tab=ads",
              "GOOGLE – https://www.google.com/settings/ads/anonymous",
            ],
          },
        ],
      },
      {
        id: "cookie",
        title: "5. Cookie",
        blocks: [
          {
            type: "p",
            text: "Chúng tôi sử dụng cookie và các công nghệ tương tự để ghi nhớ lựa chọn của bạn (ví dụ: lựa chọn đối với thông báo cookie), phân tích lưu lượng truy cập và tối ưu hóa trải nghiệm của bạn trên Trang web.",
          },
          {
            type: "p",
            text: "Bạn có thể kiểm soát và quản lý cookie theo nhiều cách khác nhau. Hầu hết các trình duyệt tự động chấp nhận cookie, nhưng bạn có thể chọn chấp nhận hoặc từ chối cookie thông qua phần cài đặt của trình duyệt. Xin lưu ý rằng việc xóa hoặc chặn cookie có thể ảnh hưởng đến trải nghiệm của bạn và một số phần của Trang web có thể không hoạt động đầy đủ.",
          },
          {
            type: "p",
            text: "Ngoài ra, việc chặn cookie có thể không hoàn toàn ngừng việc chia sẻ thông tin với các bên thứ ba. Để thực hiện quyền của bạn hoặc từ chối một số cách sử dụng thông tin của các bên này, vui lòng làm theo hướng dẫn tại mục “Phân tích và quảng cáo theo hành vi” ở trên.",
          },
        ],
      },
      {
        id: "co-so-phap-ly",
        title: "6. Cơ sở pháp lý",
        blocks: [
          {
            type: "p",
            text: "Chúng tôi xử lý Thông Tin Cá Nhân của bạn theo quy định của pháp luật Việt Nam về bảo vệ dữ liệu cá nhân và, trong phạm vi áp dụng, Quy định Bảo vệ Dữ liệu Chung (“GDPR”) đối với cư dân Khu vực Kinh tế Châu Âu (“EEA”), dựa trên các cơ sở sau:",
          },
          {
            type: "ul",
            items: [
              "Sự đồng ý của bạn;",
              "Thực hiện hợp đồng hoặc các bước cần thiết trước khi giao kết hợp đồng theo yêu cầu của bạn;",
              "Tuân thủ các nghĩa vụ pháp lý của chúng tôi;",
              "Bảo vệ lợi ích thiết yếu của bạn hoặc của người khác;",
              "Lợi ích hợp pháp của chúng tôi, với điều kiện không xâm phạm đến quyền và tự do cơ bản của bạn.",
            ],
          },
        ],
      },
      {
        id: "luu-tru",
        title: "7. Lưu trữ",
        blocks: [
          {
            type: "p",
            text: "Khi bạn để lại thông tin qua Trang web, chúng tôi sẽ lưu giữ Thông Tin Cá Nhân của bạn trong thời gian cần thiết để thực hiện các mục đích nêu trong Chính sách này, hoặc cho đến khi bạn yêu cầu chúng tôi xóa thông tin, trừ trường hợp pháp luật yêu cầu lưu trữ lâu hơn. Để biết thêm về quyền xóa dữ liệu, vui lòng tham khảo mục “Quyền của bạn” dưới đây.",
          },
          {
            type: "p",
            text: "Thông Tin Cá Nhân của bạn được lưu trữ và xử lý tại [Quốc gia/khu vực đặt máy chủ lưu trữ dữ liệu] và có thể được xử lý bởi các nhà cung cấp dịch vụ nêu tại mục 3 ở ngoài lãnh thổ Việt Nam.",
          },
        ],
      },
      {
        id: "bao-mat-thong-tin",
        title: "8. Bảo mật thông tin",
        blocks: [
          {
            type: "p",
            text: "Chúng tôi áp dụng các biện pháp kỹ thuật và tổ chức phù hợp như mã hóa đường truyền (HTTPS) và giới hạn quyền truy cập để bảo vệ Thông Tin Cá Nhân của bạn khỏi việc truy cập, sử dụng, thay đổi hoặc tiết lộ trái phép. Tuy nhiên, không có phương thức truyền tải qua Internet hay lưu trữ điện tử nào an toàn tuyệt đối.",
          },
        ],
      },
      {
        id: "quyet-dinh-tu-dong",
        title: "9. Quyết định tự động",
        blocks: [
          {
            type: "p",
            text: "Chúng tôi không thực hiện các quyết định hoàn toàn tự động (bao gồm cả việc lập hồ sơ/phân tích) có tác động pháp lý hoặc ảnh hưởng đáng kể khác đến bạn dựa trên Thông Tin Cá Nhân của bạn. Nếu bạn là cư dân EEA, bạn có quyền phản đối việc xử lý chỉ dựa trên quyết định tự động như vậy.",
          },
        ],
      },
      {
        id: "quyen-cua-ban",
        title: "10. Quyền của bạn",
        blocks: [
          {
            type: "p",
            text: "Theo quy định của pháp luật hiện hành, bạn có các quyền sau đối với Thông Tin Cá Nhân của mình:",
          },
          {
            type: "ul",
            items: [
              "Quyền được biết về việc xử lý Thông Tin Cá Nhân của bạn;",
              "Quyền truy cập và nhận bản sao Thông Tin Cá Nhân mà chúng tôi lưu giữ về bạn;",
              "Quyền yêu cầu chỉnh sửa, cập nhật Thông Tin Cá Nhân;",
              "Quyền yêu cầu xóa Thông Tin Cá Nhân;",
              "Quyền rút lại sự đồng ý, phản đối hoặc yêu cầu hạn chế xử lý (bao gồm việc nhận thông tin tiếp thị);",
              "Quyền yêu cầu chuyển Thông Tin Cá Nhân sang dịch vụ khác (trong phạm vi pháp luật cho phép);",
              "Quyền khiếu nại, tố cáo theo quy định của pháp luật.",
            ],
          },
          {
            type: "p",
            text: "Nếu bạn muốn thực hiện các quyền này, vui lòng liên hệ với chúng tôi qua email info@exceltech.vn. Chúng tôi có thể cần xác minh danh tính của bạn trước khi xử lý yêu cầu. Nếu bạn muốn chỉ định một người đại diện được ủy quyền để gửi yêu cầu thay bạn, vui lòng liên hệ với chúng tôi theo địa chỉ email ở trên.",
          },
        ],
      },
      {
        id: "do-not-track",
        title: "11. Do Not Track",
        blocks: [
          {
            type: "p",
            text: "Xin lưu ý rằng vì hiện chưa có tiêu chuẩn thống nhất trong ngành về cách phản hồi tín hiệu “Do Not Track”, chúng tôi không thay đổi các hoạt động thu thập và sử dụng dữ liệu khi phát hiện tín hiệu này từ trình duyệt của bạn.",
          },
        ],
      },
      {
        id: "thay-doi",
        title: "12. Thay đổi",
        blocks: [
          {
            type: "p",
            text: "Chúng tôi có thể cập nhật Chính sách bảo mật này theo thời gian để phản ánh những thay đổi trong hoạt động của chúng tôi hoặc vì các lý do vận hành, pháp lý hay quy định khác. Phiên bản mới sẽ được đăng tải trên trang này kèm ngày cập nhật.",
          },
        ],
      },
      {
        id: "lien-he",
        title: "13. Liên hệ",
        blocks: [
          {
            type: "p",
            text: "Để biết thêm thông tin về chính sách bảo mật của chúng tôi, nếu bạn có câu hỏi hoặc muốn khiếu nại, vui lòng liên hệ với chúng tôi qua email info@exceltech.vn hoặc số điện thoại +84 28 7300 1811.",
          },
        ],
      },
    ],
    company: {
      brand: "Excel Technologies",
      legalName: "[Tên pháp nhân đầy đủ của công ty]",
    },
  },
  en: {
    updatedAt: "September 2026",
    intro:
      "This Privacy Policy describes how Excel Technologies (ExcelTech), the owner and operator of exceltech.vn (the “Site”, “we” or “us”), collects, uses, stores and shares your Personal Information when you visit the Site, send us a contact request, subscribe to our newsletter or apply for a job through the Site.",
    sections: [
      {
        id: "thu-thap-thong-tin",
        title: "1. Personal Information we collect",
        blocks: [
          {
            type: "p",
            text: "When you visit the Site, we collect certain information about your device and how you interact with the Site. When you submit a contact form, subscribe to our newsletter, use the live chat or apply for a job, we also collect the information you provide in order to handle your request. In this Privacy Policy, we refer to any information that can identify an individual (including the information below) as “Personal Information”.",
          },
          { type: "h4", text: "Device information" },
          {
            type: "ul",
            items: [
              "Examples of Personal Information collected: web browser version, IP address, time zone, cookie information, the pages you view and how you interact with the Site.",
              "Purpose of collection: to load the Site accurately for you and to analyse Site usage in order to optimise the Site.",
              "Source of collection: collected automatically when you access the Site using cookies and similar technologies (e.g. Google Analytics).",
            ],
          },
          { type: "h4", text: "Contact and consultation requests" },
          {
            type: "ul",
            items: [
              "Examples of Personal Information collected: full name, phone number, email address, company name, job title and the message you send through the “Contact us” form.",
              "Purpose of collection: to respond to your request and advise you on our solutions and services.",
              "Source of collection: provided directly by you.",
            ],
          },
          { type: "h4", text: "Newsletter subscription" },
          {
            type: "ul",
            items: [
              "Examples of Personal Information collected: the email address you submit in the Site footer.",
              "Purpose of collection: to send you news, events and updates about our solutions and services.",
            ],
          },
          { type: "h4", text: "Job applications" },
          {
            type: "ul",
            items: [
              "Examples of Personal Information collected: full name, email address, phone number, CV/résumé and any other information you provide when applying under “Career”.",
              "Purpose of collection: to review your application, contact you for interviews and run our recruitment process.",
            ],
          },
          { type: "h4", text: "Live chat support" },
          {
            type: "ul",
            items: [
              "Examples of Personal Information collected: your name, contact details and the content of your conversation in the live chat window on the Site.",
              "Purpose of collection: to support you and answer your questions.",
            ],
          },
        ],
      },
      {
        id: "su-dung-thong-tin",
        title: "2. How we use your Personal Information",
        blocks: [
          {
            type: "p",
            text: "We use your Personal Information to:",
          },
          {
            type: "ul",
            items: [
              "Respond to contact requests and provide information about our solutions and services;",
              "Process job applications and contact candidates;",
              "Send you news, events and new offers (you can unsubscribe at any time);",
              "Analyse, operate and improve the Site;",
              "Keep the Site secure and detect or prevent fraud or unauthorised access;",
              "Comply with our legal obligations.",
            ],
          },
        ],
      },
      {
        id: "chia-se-thong-tin",
        title: "3. Sharing your Personal Information",
        blocks: [
          {
            type: "p",
            text: "We do not sell your Personal Information. We only share it with service providers that help us operate the Site and handle your requests as described above. We use the following additional services:",
          },
          {
            type: "ul",
            items: [
              "Google Analytics (traffic analytics): https://marketingplatform.google.com/about/analytics/",
              "EmailJS (forwarding contact form submissions to our mailbox): https://www.emailjs.com",
              "Mirabot – Tenten (live chat): https://tenten.vn",
              "CX Genie (live chat): https://cxgenie.ai",
              "YouTube (videos embedded on the Site): https://www.youtube.com",
            ],
          },
          {
            type: "p",
            text: "We may also share your Personal Information to comply with applicable laws and regulations, to respond to a lawful request from competent authorities, or to protect our rights and legitimate interests.",
          },
        ],
      },
      {
        id: "phan-tich-quang-cao",
        title: "4. Analytics and behavioural advertising",
        blocks: [
          {
            type: "ul",
            items: [
              "We use Google Analytics to understand how our customers use the Site. You can read more about how Google uses your Personal Information here: https://policies.google.com/privacy?hl=en. You can also opt out of Google Analytics here: https://tools.google.com/dlpage/gaoptout",
              "If we run targeted advertising on third-party platforms, information about your use of the Site may be shared with our advertising partners through cookies or similar technologies (subject to your consent).",
            ],
          },
          {
            type: "p",
            text: "For more information about how targeted advertising works, you can visit the Network Advertising Initiative’s (“NAI”) educational page: https://thenai.org. You can opt out of targeted advertising by using the links below:",
          },
          {
            type: "ul",
            items: [
              "FACEBOOK – https://www.facebook.com/settings/?tab=ads",
              "GOOGLE – https://www.google.com/settings/ads/anonymous",
            ],
          },
        ],
      },
      {
        id: "cookie",
        title: "5. Cookies",
        blocks: [
          {
            type: "p",
            text: "We use cookies and similar technologies to remember your choices (for example, your choice on the cookie notice), analyse traffic and optimise your experience on the Site.",
          },
          {
            type: "p",
            text: "You can control and manage cookies in various ways. Most browsers accept cookies automatically, but you can choose to accept or refuse cookies through your browser settings. Please note that removing or blocking cookies can negatively impact your experience and parts of the Site may no longer be fully accessible.",
          },
          {
            type: "p",
            text: "Blocking cookies may not completely prevent how we share information with third parties. To exercise your rights or opt out of certain uses of your information by these parties, please follow the instructions in the “Analytics and behavioural advertising” section above.",
          },
        ],
      },
      {
        id: "co-so-phap-ly",
        title: "6. Legal basis",
        blocks: [
          {
            type: "p",
            text: "We process your Personal Information in accordance with Vietnamese personal data protection laws and, where applicable, the General Data Protection Regulation (“GDPR”) for residents of the European Economic Area (“EEA”), on the following legal bases:",
          },
          {
            type: "ul",
            items: [
              "Your consent;",
              "The performance of a contract, or steps taken at your request before entering into a contract;",
              "Compliance with our legal obligations;",
              "To protect your vital interests or those of another person;",
              "Our legitimate interests, provided they do not override your fundamental rights and freedoms.",
            ],
          },
        ],
      },
      {
        id: "luu-tru",
        title: "7. Retention",
        blocks: [
          {
            type: "p",
            text: "When you submit information through the Site, we keep your Personal Information for as long as necessary for the purposes described in this Policy, or until you ask us to delete it, unless a longer retention period is required by law. For more information on your right of erasure, please see the “Your rights” section below.",
          },
          {
            type: "p",
            text: "Your Personal Information is stored and processed in [Country/region where data is hosted] and may be processed outside Vietnam by the service providers listed in section 3.",
          },
        ],
      },
      {
        id: "bao-mat-thong-tin",
        title: "8. Security",
        blocks: [
          {
            type: "p",
            text: "We apply appropriate technical and organisational measures, such as encrypted connections (HTTPS) and restricted access, to protect your Personal Information against unauthorised access, use, alteration or disclosure. However, no method of transmission over the Internet or electronic storage is completely secure.",
          },
        ],
      },
      {
        id: "quyet-dinh-tu-dong",
        title: "9. Automated decision-making",
        blocks: [
          {
            type: "p",
            text: "We do not make fully automated decisions (including profiling) that have a legal or similarly significant effect on you based on your Personal Information. If you are an EEA resident, you have the right to object to processing based solely on such automated decision-making.",
          },
        ],
      },
      {
        id: "quyen-cua-ban",
        title: "10. Your rights",
        blocks: [
          {
            type: "p",
            text: "Subject to applicable law, you have the following rights regarding your Personal Information:",
          },
          {
            type: "ul",
            items: [
              "The right to be informed about the processing of your Personal Information;",
              "The right to access and obtain a copy of the Personal Information we hold about you;",
              "The right to request correction or updating of your Personal Information;",
              "The right to request deletion of your Personal Information;",
              "The right to withdraw consent, object to or restrict processing (including marketing communications);",
              "The right to data portability (to the extent permitted by law);",
              "The right to lodge a complaint in accordance with the law.",
            ],
          },
          {
            type: "p",
            text: "If you would like to exercise these rights, please contact us at info@exceltech.vn. We may need to verify your identity before processing your request. If you would like to designate an authorised agent to submit these requests on your behalf, please contact us at the email address above.",
          },
        ],
      },
      {
        id: "do-not-track",
        title: "11. Do Not Track",
        blocks: [
          {
            type: "p",
            text: "Please note that because there is no consistent industry understanding of how to respond to “Do Not Track” signals, we do not alter our data collection and usage practices when we detect such a signal from your browser.",
          },
        ],
      },
      {
        id: "thay-doi",
        title: "12. Changes",
        blocks: [
          {
            type: "p",
            text: "We may update this Privacy Policy from time to time to reflect changes to our practices or for other operational, legal or regulatory reasons. The updated version will be posted on this page together with its update date.",
          },
        ],
      },
      {
        id: "lien-he",
        title: "13. Contact",
        blocks: [
          {
            type: "p",
            text: "For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by email at info@exceltech.vn or by phone at +84 28 7300 1811.",
          },
        ],
      },
    ],
    company: {
      brand: "Excel Technologies",
      legalName: "[Company full legal name]",
    },
  },
};
